import React from 'react';
import ReactDOM from 'react-dom';
import './css/bootstrap/bootstrap.css';
import './css/bootstrap/bootstrap.3.4.1.min.css';
import './css/appCss/style.css';
import App from './App';
import { HashRouter } from 'react-router-dom'
import './lib/fetchInterceptor'
import midasLogo from './img/midaslifecare_logo.png';

// Replace the default CRA favicon/apple-touch icon with the Midas Lifecare logo
const ensureLinkTag = (rel, type) => {
  const existing = document.querySelector(`link[rel="${rel}"]`);
  const link = existing || document.createElement('link');
  link.rel = rel;
  if (type) {
    link.type = type;
  }
  link.href = midasLogo;
  if (!existing) {
    document.head.appendChild(link);
  }
};

ensureLinkTag('icon', 'image/png');
ensureLinkTag('apple-touch-icon');

ReactDOM.render(
  <HashRouter>
    <App />
  </HashRouter>,
  document.getElementById('root')
);
